import { createAction } from 'redux-actions';
import { createDeferredAction } from '../../utils/redux';
import { FAILED, SUCCESSFUL } from '../../configs/actionNames';
import { AUTHORIZED_MODULE } from '../../configs/moduleNames';

export const AUTHORIZED_REGISTRATION = '_AUTHORIZED_REGISTRATION';
export const AUTHORIZED_LOGIN = '_AUTHORIZED_LOGIN';
export const AUTHORIZED_LOGOUT = '_AUTHORIZED_LOGOUT';
export const AUTHORIZED_CHECK = '_AUTHORIZED_CHECK';
export const AUTHORIZED_REFRESH = '_AUTHORIZED_REFRESH';
export const FORGOT_PASSWORD = '_FORGOT_PASSWORD';
export const UPDATE_PASSWORD = '_UPDATE_PASSWORD';
export const LOAD_NOTIFICATION = '_LOAD_NOTIFICATION';
export const MARK_ALL = '_MARK_ALL';
export const DELETE_NOTIFICATION = '_DELETE_NOTIFICATION';

export const authorizedRegistration = createDeferredAction(AUTHORIZED_MODULE + AUTHORIZED_REGISTRATION, formValues => (formValues));
export const authorizedLogin = createDeferredAction(AUTHORIZED_MODULE + AUTHORIZED_LOGIN, formValues => (formValues));
export const authorizedLogout = createDeferredAction(AUTHORIZED_MODULE + AUTHORIZED_LOGOUT);
export const authorizedLogoutSuccessful = createAction(AUTHORIZED_MODULE + AUTHORIZED_LOGOUT + SUCCESSFUL);
export const authorizedLoginSuccessful = createAction(AUTHORIZED_MODULE + AUTHORIZED_LOGIN + SUCCESSFUL, authorizedData => (authorizedData));
export const authorizedLoginFailed = createAction(AUTHORIZED_MODULE + AUTHORIZED_LOGIN + FAILED, formValues => (formValues));
export const authorizedCheck = createDeferredAction(AUTHORIZED_MODULE + AUTHORIZED_CHECK);
export const authorizedCheckSuccess = createAction(AUTHORIZED_MODULE + AUTHORIZED_CHECK + SUCCESSFUL);
export const authorizedCheckFailed = createAction(AUTHORIZED_MODULE + AUTHORIZED_CHECK + FAILED);
export const authorizedRefresh = createDeferredAction(AUTHORIZED_MODULE + AUTHORIZED_REFRESH);
export const authorizedRefreshSuccessful = createAction(AUTHORIZED_MODULE + AUTHORIZED_REFRESH + SUCCESSFUL, tokenData => tokenData);
export const authorizedRefreshFailed = createAction(AUTHORIZED_MODULE + AUTHORIZED_REFRESH + FAILED);

export const forgotPassword = createDeferredAction(AUTHORIZED_MODULE + FORGOT_PASSWORD);
export const forgotPasswordSuccessful = createAction(AUTHORIZED_MODULE + FORGOT_PASSWORD + SUCCESSFUL);
export const forgotPasswordFailed = createAction(AUTHORIZED_MODULE + FORGOT_PASSWORD + FAILED);

export const updatePassword = createDeferredAction(AUTHORIZED_MODULE + UPDATE_PASSWORD);
export const updatePasswordSuccessful = createAction(AUTHORIZED_MODULE + UPDATE_PASSWORD + SUCCESSFUL);
export const updatePasswordFailed = createAction(AUTHORIZED_MODULE + UPDATE_PASSWORD + FAILED);

export const loadNotification = createDeferredAction(AUTHORIZED_MODULE + LOAD_NOTIFICATION);
export const loadNotificationSuccessful = createAction(AUTHORIZED_MODULE + LOAD_NOTIFICATION + SUCCESSFUL);
export const loadNotificationFailed = createAction(AUTHORIZED_MODULE + LOAD_NOTIFICATION + FAILED);

export const deleteNotification = createDeferredAction(AUTHORIZED_MODULE + DELETE_NOTIFICATION);
export const deleteNotificationSuccessful = createAction(AUTHORIZED_MODULE + DELETE_NOTIFICATION + SUCCESSFUL);
export const deleteNotificationFailed = createAction(AUTHORIZED_MODULE + DELETE_NOTIFICATION + FAILED);

export const markAllNotification = createDeferredAction(AUTHORIZED_MODULE + MARK_ALL);
export const markAllNotificationSuccessful = createAction(AUTHORIZED_MODULE + MARK_ALL + SUCCESSFUL);
export const markAllNotificationFailed = createAction(AUTHORIZED_MODULE + MARK_ALL + FAILED);
